<template>
  <div>
    <cashback-accumulate-points v-model="purchaseLimits.black_list" @update-blocks="updateBlocks" />
    <cashback-cpf-points-limit v-model="purchaseLimits.coupons_limit" @update-limits="updateBlocks" />
    <cashback-purchases-without-points />
  </div>
</template>

<script>
import { QUERY_PURCHASE_LIMIT_CASHBACK, MUTATION_PURCHASE_LIMIT_CASHBACK } from '../../graphql'
import { mapState } from 'vuex'
import CashbackAccumulatePoints from '../components/CashbackAccumulatePoints.vue'
import CashbackCpfPointsLimit from '../components/CashbackCpfPointsLimit.vue'
import CashbackPurchasesWithoutPoints from '../components/CashbackPurchasesWithoutPoints.vue'

export default {
  name: 'CashbackCpfBlock',
  components: {
    CashbackAccumulatePoints,
    CashbackCpfPointsLimit,
    CashbackPurchasesWithoutPoints,
  },
  data: () => ({
    purchaseLimits: {
      black_list: {
        active: false,
      },
      coupons_limit: {
        active: false,
        limit_per_day: 0,
      },
    },
  }),
  computed: {
    ...mapState(['smartClientId']),
    getDefaultPurchaseLimit() {
      const { id_external } = this.$getLoggedUser()
      return id_external === this.smartClientId ? 3 : 2
    },
  },
  mounted() {
    this.getPurchaseLimit()
  },
  methods: {
    queryExtraArgs() {
      const extraArgs = {}
      extraArgs.context = {
        uri: this.$microservicesUrls['cashback'],
      }
      return extraArgs
    },
    async updateBlocks(alertText) {
      const variables = {
        black_list: this.purchaseLimits.black_list,
        coupons_limit: {
          active: this.purchaseLimits.coupons_limit.active,
        },
      }

      if (this.purchaseLimits.coupons_limit.active === true) {
        variables.coupons_limit.limit_per_day = this.purchaseLimits.coupons_limit.limit_per_day
      }

      await this.$apollo
        .mutate({
          mutation: MUTATION_PURCHASE_LIMIT_CASHBACK,
          variables: variables,
          ...this.queryExtraArgs(),
        })
        .then(() => {
          this.$snackbar({ message: alertText, snackbarColor: 'success' })
          this.saveButtonEnable = false
        })
        .catch(() => {
          this.$snackbar({ message: 'Erro ao atualizar.', snackbarColor: 'error' })
        })
    },
    async getPurchaseLimit() {
      await this.$apollo
        .query({
          query: QUERY_PURCHASE_LIMIT_CASHBACK,
          fetchPolicy: 'no-cache',
          ...this.queryExtraArgs(),
        })
        .then(({ data }) => {
          const {
            black_list: { active: activeBlackList },
            coupons_limit: { active: activeLimit, limit_per_day },
          } = data.cashbackDiscountsBlocksConfiguration
          const limitPerDay = limit_per_day ?? this.getDefaultPurchaseLimit

          this.purchaseLimits.coupons_limit.limit_per_day = limitPerDay
          this.purchaseLimits.coupons_limit.active = activeLimit ?? false
          this.purchaseLimits.black_list.active = activeBlackList ?? false
        })
        .catch(() => {
          this.$snackbar({ message: 'Erro ao buscar limite de pontos.', snackbarColor: 'error' })
        })
    },
  },
}
</script>

<style lang="scss">
.text-field-width {
  max-width: 300px;
}
</style>
